<template>
  <div class="bg-background-primary">
    <RouteProgressBar />
    <div v-if="userStore.isLoading" class="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner color="primary" />
    </div>

    <NetworkError v-else-if="userStore.hasNetworkError" class="h-screen w-screen" />

    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingSpinner from "./components/LoadingSpinner.vue";
import NetworkError from "./components/NetworkError.vue";
import RouteProgressBar from "./components/RouteProgressBar.vue";
import { useCustomerCartLifecycle } from "./composables/useCustomerCartLifecycle";
import { useUserStore } from "./store/user";

const userStore = useUserStore();
if (import.meta.env.VITE_PROJECT_TYPE === "user") useCustomerCartLifecycle();
</script>
